import * as React from 'react';
import { memo } from 'react';
const SvgDensityNotSure = (props) => (
  <svg width={254} height={197} viewBox="0 0 254 197" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <circle cx={127.477} cy={98.5} r={32.375} fill="#212322" className="circle" />
    <path
      d="M129.311 104.34V103.38C129.311 100.5 130.831 99.14 132.471 97.66C134.471 95.86 135.951 94.34 135.951 91.06C135.951 86.14 132.711 83.02 127.791 83.02C120.671 83.02 118.751 87.98 118.751 91.34L122.311 91.94C122.311 89.78 122.831 86.02 127.631 86.02C130.751 86.02 132.391 87.7 132.391 91.02C132.391 93.34 130.871 94.66 129.351 96.06C126.831 98.38 125.911 100.14 125.911 102.5V104.34H129.311ZM129.871 111.5V106.94H125.511V111.5H129.871Z"
      fill="#FFFDED"
    />
  </svg>
);
const Memo = memo(SvgDensityNotSure);
export default Memo;
